import { InitApp } from '@/helpers/main'
import { createPinia } from 'pinia'

import QuickBooking from './quick-booking/QuickBooking.vue'
import PosScreen from './pos/PosScreen.vue'
import posEs from './pos/i18n/es.js'

import VueTelInput from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'

const pinia = createPinia()
const app = InitApp()

app.component('quickBooking', QuickBooking)
app.component('posScreen', PosScreen)

// Textos del POS (namespace `pos.*`): el resto de la app los publica el layout
// via window.localMessagesUpdate, pero los del POS viven en JS y se inyectan aqui
// sobre la instancia i18n que crea InitApp (expuesta como window.i18n). Solo hay
// es.js; se mergea bajo el locale actual (la app se usa en espanol).
const locale = document.documentElement.lang || 'en'
window.i18n?.global?.mergeLocaleMessage(locale, { pos: posEs })

app.use(pinia)
app.use(VueTelInput)
app.mount('[data-render="app"]');
